import { Routes } from '@angular/router'
import { DashboardGuard } from '@shared/guards/dashboard.guard'
import {
  NgxGfmoneyCreateMessageComponent,
  NgxGfmoneyMessageComponent,
  NgxGfmoneyMessagesComponent,
} from '@yuri.karkhachev/ngx-gfmoney-support'

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./flow/layout/layout.component').then(m => m.LayoutComponent),
    children: [
      { path: '', redirectTo: '/loans/credit-card', pathMatch: 'full' },
      {
        path: 'brokers/:guid',
        redirectTo: route => {
          const id = route.params['guid']
          return `/resume/${id}`
        },
      },
      {
        path: 'loans/:type',
        loadComponent: () => import('./flow/home/home.component').then(m => m.HomeComponent),
      },
      {
        path: 'brokers-consent',
        loadComponent: () =>
          import('./flow/brokers-consent/brokers-consent.component').then(m => m.BrokersConsentComponent),
      },
      {
        path: 'bank-login',
        loadComponent: () => import('./flow/bank-login/bank-login.component').then(m => m.BankLoginComponent),
      },
      {
        path: 'customer-details',
        loadComponent: () =>
          import('./flow/customer-details/customer-details.component').then(m => m.CustomerDetailsComponent),
      },
      {
        path: 'address-confirmation',
        loadComponent: () =>
          import('./flow/address-confirmation/address-confirmation.component').then(
            m => m.AddressConfirmationComponent,
          ),
      },
      {
        path: 'transactions-check',
        loadComponent: () =>
          import('./flow/transactions-check/transactions-check.component').then(m => m.TransactionsCheckComponent),
      },
      {
        path: 'transactions-check-retry',
        loadComponent: () =>
          import('./flow/transactions-check-retry/transactions-check-retry.component').then(
            m => m.TransactionsCheckRetryComponent,
          ),
      },
      {
        path: 'transactions-check-redirect',
        loadComponent: () =>
          import('./flow/transactions-check-redirect/transactions-check-redirect.component').then(
            m => m.TransactionsCheckRedirectComponent,
          ),
      },
      {
        path: 'extra-details',
        loadComponent: () => import('./flow/extra-details/extra-details.component').then(m => m.ExtraDetailsComponent),
      },
      {
        path: 'credit-card',
        loadComponent: () => import('./flow/credit-card/credit-card.component').then(m => m.CreditCardComponent),
      },
      {
        path: 'card-password',
        loadComponent: () => import('./flow/card-password/card-password.component').then(m => m.CardPasswordComponent),
      },
      {
        path: 'terms-and-conditions',
        loadComponent: () =>
          import('./flow/terms-and-conditions/terms-and-conditions.component').then(m => m.TermsAndConditionsComponent),
      },
      {
        path: 'bank-authorization',
        loadComponent: () => import('./flow/terms-sign/terms-sign.component').then(m => m.TermsSignComponent),
      },
      {
        path: 'decision-rejected',
        loadComponent: () =>
          import('./flow/decision-rejected/decision-rejected.component').then(m => m.DecisionRejectedComponent),
      },
      {
        path: 'decision-pending',
        loadComponent: () =>
          import('./flow/decision-pending/decision-pending.component').then(m => m.DecisionPendingComponent),
      },
      {
        path: 'decision-success',
        loadComponent: () =>
          import('./flow/decision-success/decision-success.component').then(m => m.DecisionSuccessComponent),
      },
      {
        path: 'resume/:guid',
        loadComponent: () => import('./flow/resume/resume.component').then(m => m.ResumeComponent),
      },
      {
        path: 'error',
        loadComponent: () => import('./flow/error/error.component').then(m => m.ErrorComponent),
      },
      {
        path: 'continue',
        loadComponent: () => import('./flow/continue/continue.component').then(m => m.ContinueComponent),
      },
      {
        path: 'invoice-payment-success',
        loadComponent: () =>
          import('./flow/invoice-payment-success/invoice-payment-success.component').then(
            m => m.InvoicePaymentSuccessComponent,
          ),
      },
      {
        path: 'invoice-payment-failure',
        loadComponent: () =>
          import('./flow/invoice-payment-failure/invoice-payment-failure.component').then(
            m => m.InvoicePaymentFailureComponent,
          ),
      },
    ],
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./dashboard/layout/layout.component').then(m => m.LayoutComponent),
    children: [
      { path: '', redirectTo: '/dashboard/home', pathMatch: 'full' },
      {
        path: 'home',
        loadComponent: () => import('./dashboard/home/home.component').then(m => m.HomeComponent),
        canActivate: [DashboardGuard],
      },
      {
        path: 'login',
        loadComponent: () => import('./dashboard/login/login.component').then(m => m.LoginComponent),
      },
      {
        path: 'invoices',
        loadComponent: () => import('./dashboard/invoices/invoices.component').then(m => m.InvoicesComponent),
        canActivate: [DashboardGuard],
      },
      {
        path: 'transactions',
        loadComponent: () =>
          import('./dashboard/transactions/transactions.component').then(m => m.TransactionsComponent),
        canActivate: [DashboardGuard],
      },
      {
        path: 'help',
        loadComponent: () => import('./dashboard/help/help.component').then(m => m.HelpComponent),
        canActivate: [DashboardGuard],
      },
      {
        path: 'profile',
        loadComponent: () => import('./dashboard/profile/profile.component').then(m => m.ProfileComponent),
        canActivate: [DashboardGuard],
      },
      {
        path: 'card',
        loadComponent: () => import('./dashboard/card/card.component').then(m => m.CardComponent),
        canActivate: [DashboardGuard],
      },
      {
        path: 'history',
        loadComponent: () => import('./dashboard/history/history.component').then(m => m.HistoryComponent),
        canActivate: [DashboardGuard],
      },
      {
        path: 'limit-raise',
        loadComponent: () => import('./dashboard/limit-raise/limit-raise.component').then(m => m.LimitRaiseComponent),
        canActivate: [DashboardGuard],
      },
      {
        path: 'messages/create',
        component: NgxGfmoneyCreateMessageComponent,
        canActivate: [DashboardGuard],
      },
      {
        path: 'messages/view/:id',
        component: NgxGfmoneyMessageComponent,
        canActivate: [DashboardGuard],
      },
      {
        path: 'messages/:type',
        component: NgxGfmoneyMessagesComponent,
        canActivate: [DashboardGuard],
      },
    ],
  },
  {
    path: '**',
    loadComponent: () => import('./flow/layout/layout.component').then(m => m.LayoutComponent),
    children: [
      {
        path: '**',
        loadComponent: () => import('./flow/error/error.component').then(m => m.ErrorComponent),
      },
    ],
  },
]
